import { FunctionComponent, MouseEvent } from 'react';
import clsx from 'clsx';
import { faEye } from '@fortawesome/pro-light-svg-icons';
import { TableRow } from 'components/UI/V3/Table/Row/TableRow';
import { TableCell } from 'components/UI/V3/Table/Cell/TableCell';
import Button from 'components/UI/V3/Button/Button';
import { VaccineApproval, VaccineApprovalDetailMode } from 'model/VaccineApproval';
import {
    formatExpirationDate,
    formatReceivedAt,
    getClientDisplayName,
    getVaccineDisplayName,
    getVaccineExpiration
} from '../utils';
import VaccineApprovalStatusChip from './VaccineApprovalStatusChip';
import styles from './VaccineApprovalsTableRow.module.scss';

interface VaccineApprovalsTableRowProps {
    item: VaccineApproval;
    timeZone: string;
    isLast?: boolean;
    onOpenDetail: (item: VaccineApproval, mode: VaccineApprovalDetailMode) => void;
}

const VaccineApprovalsTableRow: FunctionComponent<VaccineApprovalsTableRowProps> = ({
    item,
    timeZone,
    onOpenDetail
}) => {
    const isPending = item.status === 'pending';
    const mode: VaccineApprovalDetailMode = isPending ? 'review' : 'readonly';

    const handleRowClick = () => {
        if (isPending) {
            return;
        }
        onOpenDetail(item, mode);
    };

    const handleViewFileClick = (event: MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        onOpenDetail(item, mode);
    };

    return (
        <TableRow
            className={clsx(styles.row, !isPending && styles.clickable)}
            onClick={handleRowClick}
        >
            <TableCell>
                <p>{formatReceivedAt(item.receivedAt, timeZone)}</p>
            </TableCell>
            <TableCell>
                <p>{getClientDisplayName(item.client.firstName, item.client.lastName)}</p>
            </TableCell>
            <TableCell>
                <p>{item.pet.name}</p>
            </TableCell>
            <TableCell>
                <p>{getVaccineDisplayName(item)}</p>
            </TableCell>
            <TableCell>
                <p>{formatExpirationDate(getVaccineExpiration(item), timeZone)}</p>
            </TableCell>
            <TableCell
                isActions
                align="right"
                className={styles.actionsCell}
            >
                {isPending ? (
                    <Button
                        label="View File"
                        variant="black"
                        size="small"
                        leftIcon={faEye}
                        onClick={handleViewFileClick}
                        className={styles.viewFileButton}
                    />
                ) : (
                    <VaccineApprovalStatusChip
                        status={item.status}
                        className={styles.statusChip}
                    />
                )}
            </TableCell>
        </TableRow>
    );
};

export default VaccineApprovalsTableRow;
